module.exports = __webpack_public_path__ + "img/我的项目.540c8a27.png";